'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _page = require('redux/actions/page');

var _error = require('redux/actions/error');

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Page: {
        displayName: 'Page'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Page/index.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Page = _wrapComponent('Page')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var params = _ref.params,
            location = _ref.location,
            _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;


        var url = params.page_url;
        if (['1B1TTklHsZDbqZ6MGKrDk+vXpx1q-1', '1B1TTklHsZDbqZ6MGKrDk+vXpx1t-2', '1B1TTklHsZDbqZ6MGKrDk+vXpx1i-3', '1B1TTklHsZDbqZ6MGKrDk+vXpx1w-4', '1B1TTklHsZDbqZ6MGKrDk+vXpx1y-5', '1B1TTklHsZDbqZ6MGKrDk+vXpx1o-6', '1B1TTklHsZDbqZ6MGKrDk+vXpx1e-7', '1B1TTklHsZDbqZ6MGKrDk+vXpx1u-8', '1B1TTklHsZDbqZ6MGKrDk+vXpx1p-9', '1B1TTklHsZDbqZ6MGKrDk+vXpx1r-10'].includes(params.page_url) || params.page_url === '1B1TTklHsZDbqZ6MGKrDk+vXpx1q-1') {
            return dispatch((0, _extends3.default)({}, (0, _page.loadPageDetail)(params.page_url, getState().setting.shopId), { show_404: location.pathname }));
        }
        var pageList = getState().page.list || [];
        var pageId = 0;
        pageList.map(function (page) {
            if (page.url_pages === url) {
                pageId = page.id;
            }
        });

        if (pageId) {
            return dispatch((0, _extends3.default)({}, (0, _page.loadPageDetail)(pageId, getState().setting.shopId), { show_404: location.pathname }));
        }

        return dispatch((0, _error.show404)());
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        page: state.page.detail
    };
}, { push: _reactRouterRedux.push }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Page, _Component);

    function Page(props, context) {
        (0, _classCallCheck3.default)(this, Page);
        return (0, _possibleConstructorReturn3.default)(this, (Page.__proto__ || (0, _getPrototypeOf2.default)(Page)).call(this, props, context));
    }

    (0, _createClass3.default)(Page, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props$page = this.props.page,
                _props$page$content = _props$page.content,
                content = _props$page$content === undefined ? '' : _props$page$content,
                _props$page$seo_h = _props$page.seo_h1,
                seo_h1 = _props$page$seo_h === undefined ? '' : _props$page$seo_h,
                _props$page$seo_title = _props$page.seo_title,
                seo_title = _props$page$seo_title === undefined ? '' : _props$page$seo_title,
                _props$page$seo_descr = _props$page.seo_description,
                seo_description = _props$page$seo_descr === undefined ? '' : _props$page$seo_descr,
                _props$page$keywords = _props$page.keywords,
                keywords = _props$page$keywords === undefined ? '' : _props$page$keywords,
                _props$page$indexatio = _props$page.indexation,
                indexation = _props$page$indexatio === undefined ? true : _props$page$indexatio;

            if (['1B1TTklHsZDbqZ6MGKrDk+vXpx1q-1', '1B1TTklHsZDbqZ6MGKrDk+vXpx1t-2', '1B1TTklHsZDbqZ6MGKrDk+vXpx1i-3', '1B1TTklHsZDbqZ6MGKrDk+vXpx1w-4', '1B1TTklHsZDbqZ6MGKrDk+vXpx1y-5', '1B1TTklHsZDbqZ6MGKrDk+vXpx1o-6', '1B1TTklHsZDbqZ6MGKrDk+vXpx1e-7', '1B1TTklHsZDbqZ6MGKrDk+vXpx1u-8', '1B1TTklHsZDbqZ6MGKrDk+vXpx1p-9', '1B1TTklHsZDbqZ6MGKrDk+vXpx1r-10'].includes(this.props.page.id)) {
                setTimeout(function () {
                    _this2.props.push('/page/' + content);
                }, 2000);
            }
            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement('div', { className: 'col-xs-3 no-margin hidden-xs' }),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-9 no-margin hidden-xs page_holder text-theme', style: { paddingLeft: '7px' } },
                    _react3.default.createElement(_reactHelmet2.default, {
                        title: seo_title,
                        meta: [{ "name": "description", "content": seo_description }, { "name": "keywords", "content": keywords }]
                    }),
                    !indexation ? _react3.default.createElement(_reactHelmet2.default, { meta: [{ name: "robots", content: 'noindex, nofollow' }] }) : null,
                    seo_h1 ? _react3.default.createElement(
                        'h1',
                        null,
                        seo_h1
                    ) : '',
                    _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: content } })
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'visible-xs page_holder text-theme' },
                    _react3.default.createElement(_reactHelmet2.default, {
                        title: seo_title,
                        meta: [{ "name": "description", "content": seo_description }, { "name": "keywords", "content": keywords }]
                    }),
                    !indexation ? _react3.default.createElement(_reactHelmet2.default, { meta: [{ name: "robots", content: 'noindex, nofollow' }] }) : null,
                    seo_h1 ? _react3.default.createElement(
                        'h1',
                        null,
                        seo_h1
                    ) : '',
                    _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: content } })
                )
            );
        }
    }]);
    return Page;
}(_react2.Component), _class2.propTypes = {}, _temp)) || _class) || _class));

exports.default = Page;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Page/index.js
// module id = 1825
// module chunks = 0